export const dropdownCloseEventName = 'closeOtherDropdowns';
